import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 0,
    padding: '32px 24px 48px 24px',
    height: '100%',
    textAlign: 'center',
  },
  iconWrapper: {
    '& svg': {
      display: 'block',
      height: 64,
      width: 'auto',
      marginBottom: 24,
      color: theme.color.oranges[50],
      [theme.breakpoints.down('sm')]: {
        marginBottom: 16,
      },
    },
  },
    title: {
      fontSize: 32,
      lineHeight: 1.12,
      marginBottom: 16,
  },
}), {name: 'BoxWithIcon', index: 2});
